import { margin } from "@mui/system";
import React from "react";
import DotsComponent from "../../DotsComponent";

const PayrollIdCard = ({data}) => {
  return (
    <>
      <div
        className="container"
        style={{ width: "30rem", margin: "0", marginRight: "1rem" }}
      >
      <DotsComponent/>
        <div
          style={{ textAlign: "center", padding: "10px", fontSize: "large" }}
        >
          <small className="camp-detail">Payroll details</small>
        </div>
        <div className="sub-container">
          <div className="active">
          <div className="active-text"> Active</div>
          </div>

          <div className="allDetailsBox">
            <div>
              <div className="customername">
                <span>Employee ID : 87987987AD</span>
                <small style={{ fontSize: "12px" }}>
                  Joined On: 18th Aug 2022{" "}
                </small>
              </div>

              <div className="details">
                <span>
                  Delivery person name: <b>Jon Aches</b>
                </span>
                <label>Email ID :jonach.123@gmail.com </label>
                <span>
                  {" "}
                  Contact details: <b>+91-7833516223</b>
                </span>
                <span>
                  {" "}
                  Department :<b>IT Dept.</b>
                </span>
                <span>
                  {" "}
                  Package: <b>12 LPA</b>
                </span>
              </div>
            </div>

            <div className="image"></div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0.5rem 5px 0 1rem",
              marginBottom:'20px'
            }}
          >
            <small>
              <b>Amount given till now:</b>
            </small>
            <span>
              <b>Rs.4,30,000.00</b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollIdCard;
